export default "__VITE_ASSET__2rSaJb$2__"